import React from 'react'
import { Public, ArrowDropDown } from '@mui/icons-material'
import { Button, CircularProgress, Tooltip, Typography } from '@mui/material'
import { useStyles } from './style'
import { useSelector } from 'react-redux'
import { contentSlice } from '../../../reducers'

const Translate = props => {
  const classes = useStyles(props)
  const isTranslating = useSelector(contentSlice.selectors.selectIsTranslating)
  const { name, onClick, className = '' } = props

  return (
    <Tooltip
      title='Translate this article'
      PopperProps={{ 'data-test': 'article-translate-tooltip' }}
    >
      <Button
        disabled={isTranslating}
        startIcon={<Public color='action' />}
        endIcon={isTranslating ? <CircularProgress size={18} className={classes.circularProgress} /> : <ArrowDropDown color='action' />}
        size='large'
        onClick={onClick}
        className={className}
        classes={{
          root: classes.button,
          startIcon: classes.startIcon,
          endIcon: classes.endIcon
        }}
        data-test='article-translate'
      >
        <Typography
          className={classes.title}
          data-test='article-translate-language'
        >
          {name}
        </Typography>
      </Button>
    </Tooltip>
  )
}

export default Translate
